export const collectionPage = {
    'collection.page.title': '{collectionName} | Коллекции игрушек | R.Toys',
    'collection.page.description': 'Ознакомьтесь с коллекцией «{collectionName}», в которую входят уникальные NFT и физические игрушки. Эта тематическая коллекция игрушек создана для настоящих ценителей.',
}
